import './styles.css';

export default function Preloader() {
    return <div id="preloader" />
}
